import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  Iktatás a SULINFORM-ból.
 *
 *  Az iskolában keletkező iratok nagy része már a rendszerben van: beadott kérvények,
 *  határozatok, bizonyítványok. Ezt a képernyőt azért írtuk, hogy ne kelljen kétszer
 *  begépelni ugyanazt – kijelölöd, mi kerüljön a könyvbe, és a szerver érkezteti,
 *  iktatja, a meglévő PDF-et pedig hivatkozásként csatolja (nem másolja le).
 */
@Component({
  selector: 'app-ikt-sulinform',
  templateUrl: './sulinform.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktSulinformComponent implements OnInit {
  forrasok: any[] = [];
  aktivForras = '';
  tetelek: any[] = [];
  kijelolt = new Set<string>();
  csakIktatatlan = true;
  szoveg = '';

  konyvek: any[] = [];
  terv: any[] = [];
  ugyintezok: any[] = [];
  beallitas: any = { konyv: '', tetelszam: '', ugyintezo: '', irany: '' };

  betoltes = false;
  folyamatban = false;
  eredmeny: any = null;

  constructor(private ikt: IktatgatoService, private data: DataService, private router: Router) {}

  async ngOnInit() {
    try {
      this.forrasok = await this.ikt.sulinformForrasok();
      this.konyvek = (await this.ikt.konyvek()).filter((k: any) => k.allapot === 'nyitva');
      if (this.konyvek.length) this.beallitas.konyv = this.konyvek[0].id;
      this.terv = await this.ikt.terv();
      this.ugyintezok = await this.ikt.ugyintezok();
      this.beallitas.ugyintezo = await this.ikt.ki();
      const elso = this.forrasok.find((f) => f.varakozo > 0) || this.forrasok[0];
      if (elso) await this.forrasValt(elso.kulcs);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A források nem tölthetők be.', 'error');
    }
  }

  get aktiv() { return this.forrasok.find((f) => f.kulcs === this.aktivForras); }

  get szurtTetelek() {
    const sz = this.szoveg.trim().toLowerCase();
    if (!sz) return this.tetelek;
    return this.tetelek.filter((t) =>
      `${t.cim} ${t.szemely} ${t.datum}`.toLowerCase().includes(sz));
  }

  async forrasValt(kulcs: string) {
    this.aktivForras = kulcs;
    this.kijelolt.clear();
    this.eredmeny = null;
    this.betoltes = true;
    try {
      const r = await this.ikt.sulinformTetelek(kulcs, this.csakIktatatlan);
      this.tetelek = r.tetelek || [];
      this.beallitas.irany = this.aktiv?.irany || 'be';
    } catch (e: any) {
      this.tetelek = [];
      this.data.sendToast(e?.error?.error || 'A lista nem tölthető be.', 'error');
    } finally {
      this.betoltes = false;
    }
  }

  valt(t: any, be: boolean) {
    if (t.mar_iktatva) return;
    if (be) this.kijelolt.add(t.azonosito); else this.kijelolt.delete(t.azonosito);
  }
  kivan(t: any) { return this.kijelolt.has(t.azonosito); }

  mindet(be: boolean) {
    if (!be) { this.kijelolt.clear(); return; }
    for (const t of this.szurtTetelek) if (!t.mar_iktatva) this.kijelolt.add(t.azonosito);
  }

  async iktat() {
    if (!this.kijelolt.size) { this.data.sendToast('Jelölj ki legalább egy tételt.', 'warning'); return; }
    if (!this.beallitas.konyv) { this.data.sendToast('Válassz iktatókönyvet.', 'warning'); return; }

    this.folyamatban = true;
    this.eredmeny = null;
    try {
      this.eredmeny = await this.ikt.sulinformIktat({
        forras: this.aktivForras,
        tetelek: Array.from(this.kijelolt),
        konyv: this.beallitas.konyv,
        tetelszam: this.beallitas.tetelszam || null,
        ugyintezo: this.beallitas.ugyintezo || null,
        irany: this.beallitas.irany,
      });
      const db = this.eredmeny.iktatva;
      this.data.sendToast(
        db ? `${db} tétel iktatva.` : 'Egyetlen tétel sem került iktatásra.',
        db ? 'success' : 'warning');
      this.kijelolt.clear();
      await this.forrasValt(this.aktivForras);
      this.forrasok = await this.ikt.sulinformForrasok();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az iktatás nem sikerült.', 'error');
    } finally {
      this.folyamatban = false;
    }
  }

  ugyiratra(s: any) { this.router.navigateByUrl('/iktatgato/ugyirat/' + s.ugyirat_id); }
}
